import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-domain-authorization-modal',
  standalone: true,
  imports: [CommonModule, IconComponent, I18nPipe],
  templateUrl: './domain-authorization-modal.component.html',
  styleUrl: './domain-authorization-modal.component.scss',
})
export class DomainAuthorizationModalComponent {
  @Input() isOpen: boolean = false;
  @Input() domain: string = '';
  @Output() closeModal = new EventEmitter<void>();
  @Output() authorize = new EventEmitter<void>();

  onClose(): void {
    this.closeModal.emit();
  }

  onAuthorize(): void {
    this.authorize.emit();
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
